import { useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Outlet, useSearchParams } from 'react-router-dom';
import * as productActions from 'actions/product';
import AppContext from 'components/app_context';
import LeftSidebar from 'components/left_sidebar';
import AddMetaTags from 'components/add_meta_tags';
import { PAGINATION } from 'constants/pagination';

function UserProducts(props) {
  const { keyword } = useContext(AppContext);
  let { productActionsCreator } = props;
  let { fetchUserProduct } = productActionsCreator;
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || 1;

  useEffect(() => {
    fetchUserProduct({ keyword: keyword, product_type: 'all', page: parseInt(page), limit: PAGINATION.ITEMS_PER_PAGE });
  }, [fetchUserProduct, keyword, page]);

  return (
    <div className="products">
      <AddMetaTags title={'Danh sách sản phẩm của người dùng'} />
      <div className="row">
        <LeftSidebar />
        <div className="col-md-9 col-sm-12">
          <div className="cont-center">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    listUserProducts: state.product.listUserProducts,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    productActionsCreator: bindActionCreators(productActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProducts);
